import { render, staticRenderFns } from "./GamesFilter.vue?vue&type=template&id=5dd06b33&scoped=true"
import script from "./GamesFilter.vue?vue&type=script&lang=js"
export * from "./GamesFilter.vue?vue&type=script&lang=js"
import style0 from "./GamesFilter.vue?vue&type=style&index=0&id=5dd06b33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd06b33",
  null
  
)

export default component.exports